import React from 'react'
import {ShowGuesser} from '@api-platform/admin'
import {TextField, BooleanField} from 'react-admin';
import {useTranslation} from "react-i18next";

function Show(props) {
    const {t} = useTranslation()
    return (
        <ShowGuesser {...props}>
            <TextField source="originId" label={t('id')}/>
            <TextField source="name" label={t('common.name')}/>
            <TextField source="description" label={t('admin.description')}/>
            <BooleanField source="isDefault" label={t('admin.isDefault')}/>
            <TextField source="order" label={t('admin.order')}/>
            <TextField source="code" label={t('admin.code')}/>
            <TextField source="duration" label={t('admin.duration')}/>
        </ShowGuesser>
    )
}

export default Show
